import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from '@99designs/common/components/Icon';
import { IconButton } from '@99designs/common/components/IconButton';

import DropdownMenu from 'components/DropdownMenu';
import { toggleRequest } from 'utils/xhr';

const toggleLikeStateFn = state => ({
    isLiked: !state.isLiked,
    likeCount: state.isLiked ? state.likeCount - 1 : state.likeCount + 1,
});

class LikeButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            likeCount: props.likeCount,
            isLiked: props.isLiked,
            likeUrl: props.likeUrl,
        };

        this.handleLikeClick = this.handleLikeClick.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.likeUrl === prevState.likeUrl) return null;

        return {
            likeCount: nextProps.likeCount,
            isLiked: nextProps.isLiked,
            likeUrl: nextProps.likeUrl,
        };
    }

    componentWillUnmount() {
        this.abortRequest();
    }

    abortRequest() {
        if (this.request) {
            this.request.abort();
        }
    }

    save() {
        this.abortRequest();
        this.request = this.props.toggleRequest(this.state.isLiked, this.state.likeUrl);
        this.request
            .then(() => {
                if (this.state.isLiked) {
                    this.props.onLike(this.state.likeCount);
                } else {
                    this.props.onUnlike(this.state.likeCount);
                }
            })
            .catch(() => {
                this.setState(toggleLikeStateFn);
            });
    }

    handleLikeClick() {
        if (this.props.canLike) {
            this.setState(toggleLikeStateFn, this.save);
        }
    }

    noPermissionMessage() {
        return <span dangerouslySetInnerHTML={{ __html: this.props.noPermissionMessage }} />;
    }

    likeCount() {
        if (!this.props.onLikeCountClick) return this.state.likeCount;

        return (
            <button className="like-button__count__link" onClick={this.props.onLikeCountClick}>
                {this.state.likeCount}
            </button>
        );
    }

    likeButton() {
        return (
            <div className="like-button">
                <div className="like-button__button">
                    <IconButton
                        variations={['soft-toggle', classNames({ selected: this.state.isLiked })]}
                        onClick={this.handleLikeClick}
                    >
                        <Icon type={'like-1'} />
                    </IconButton>
                </div>
                <div className="like-button__count">{this.likeCount()}</div>
            </div>
        );
    }

    render() {
        if (!this.props.canLike) {
            return (
                <DropdownMenu
                    itemData={[
                        {
                            label: this.noPermissionMessage(),
                            key: 'like',
                        },
                    ]}
                >
                    {this.likeButton()}
                </DropdownMenu>
            );
        }
        return this.likeButton();
    }
}

LikeButton.defaultProps = {
    likeCount: 0,
    onLikeCountClick: false,
    onLike: () => undefined,
    onUnlike: () => undefined,
    toggleRequest: toggleRequest,
    canLike: false,
};

LikeButton.propTypes = {
    isLiked: PropTypes.bool.isRequired,
    likeUrl: PropTypes.string.isRequired,
    likeCount: PropTypes.number,
    onLikeCountClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    onLike: PropTypes.func,
    onUnlike: PropTypes.func,
    toggleRequest: PropTypes.func,
    canLike: PropTypes.bool,
    noPermissionMessage: PropTypes.any,
};

export default LikeButton;



// WEBPACK FOOTER //
// ./src/js/components/LikeButton.jsx